<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="showDialogForm"
      :modal-append-to-body="false"
      width="400px"
      top="300px"
      @closed="closedSyncDialog"
    >
      <div>
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          label-width="120px"
          margin-top="10px"
          margin-right="5px"
          :rules="rules"
        >
          <el-row :gutter="10">
            <el-col offset="2" :span="22"
              ><el-icon class="el-icon-question"></el-icon
              >请确认同步所有信息还是最近修改的信息！</el-col
            >
            <el-col></el-col>
            <el-col></el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col offset="4">
              <el-button type="primary" plain @click="syncParkInfo(2)" :disabled="btnDisabled"
                >所有信息</el-button
              >
              <el-button type="success" plain @click="syncParkInfo(1)" :disabled="true"
                >最近更新</el-button
              >
              <el-button type="warning" plain @click="closeSyncDialog" :disabled="btnDisabled"
                >放弃操作</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { syncData } from '@/api/v4ward/carv2/carparkspace';

export default {
  data() {
    return {
      showDialogForm: false,
      title: '',
      btnDisabled: false,
      syncParam: {},
    };
  },
  created() {},
  mounted() {},
  methods: {
    //dataRange = 2 - 全部； 1-最近更新
    syncParkInfo(dataRange) {
      this.btnDisabled = true;
      this.syncParam.dataRange = dataRange;
      syncData(this.syncParam).then(
        () => {
          this.$message.success('操作成功！');
          this.closeSyncDialog();
        },
        (error) => {
          window.console.log(error);
          this.btnDisabled = false;
        }
      );
    },
    closeSyncDialog() {
      this.showDialogForm = false;
    },
    closedSyncDialog() {
      this.syncParam = {};
      this.btnDisabled = false;
      this.title = '';
      this.$emit('closeSyncForm');
    },
    openSyncDialogForm(title, type, id) {
      this.title = title;
      this.showDialogForm = true;
      this.syncParam = {
        dataType: type,
        parkId: id,
      };
    },
  },
};
</script>

<style>
.el-dialog__body {
  padding-right: 60px;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
